/**
 * Product Hierarchy API Service
 * 
 * Handles all API calls related to product hierarchy
 */
import { apiService as api } from './api.service';

// API endpoints
const ENDPOINTS = {
  HIERARCHY: '/product-hierarchy/',
  NODE_BY_ID: (id) => `/product-hierarchy/nodes/${id}`,
  NODE_PRODUCTS: (id) => `/product-hierarchy/nodes/${id}/products`,
  NODES: '/product-hierarchy/nodes',
  SEARCH: '/product-hierarchy/search',
  STATISTICS: '/product-hierarchy/statistics',
  LEVELS: '/product-hierarchy/levels',
  LEVEL_NODES: (id) => `/product-hierarchy/levels/${id}/nodes`,
};

/**
 * Product Hierarchy API functions
 */
export const productHierarchyService = {
  // Hierarchy
  getCompleteHierarchy: () => api.get(ENDPOINTS.HIERARCHY),
  
  // Nodes
  getNodeById: (id) => api.get(ENDPOINTS.NODE_BY_ID(id)),
  getNodeProducts: (id, limit = 10, offset = 0) => 
    api.get(ENDPOINTS.NODE_PRODUCTS(id), { params: { limit, offset } }),
  createNode: (data) => api.post(ENDPOINTS.NODES, data),
  updateNode: (id, data) => api.put(ENDPOINTS.NODE_BY_ID(id), data),
  deleteNode: (id) => api.delete(ENDPOINTS.NODE_BY_ID(id)),
  
  // Search
  searchHierarchy: (query) => api.get(ENDPOINTS.SEARCH, { params: { query } }),
  
  // Statistics
  getHierarchyStatistics: () => api.get(ENDPOINTS.STATISTICS),
  
  // Levels
  getHierarchyLevels: () => api.get(ENDPOINTS.LEVELS),
  getNodesByLevel: (levelId) => api.get(ENDPOINTS.LEVEL_NODES(levelId)),
}; 